export const REQUEST_INFO_SCHEMA = {
  leftSchema: {
    transactionNumber: {
      title: 'userManagement.packageSubManagement.TRANSACTION_NO',
      key: 'transactionCode',
    },
    requestNumber: {
      title: 'userManagement.packageSubManagement.REQUEST_NO',
      key: 'id',
    },
    requestType: {
      title: 'userManagement.packageSubManagement.REQUEST_TYPE',
      key: 'orderType',
    },
    requestStatus: {
      title: 'userManagement.packageSubManagement.REQUEST_STATUS',
      key: 'status',
    },
    paymentMethod: {
      title: 'userManagement.packageSubManagement.PAYMENT_METHOD',
      key: 'paymentMethod',
    },
    dateRequested: {
      title: 'userManagement.packageSubManagement.DATE_REQUESTED',
      key: 'createDate',
    },
    paymentStatus: {
      title: 'userManagement.packageSubManagement.PAYMENT_STATUS',
      key: 'transactionStatus',
    },
  },
  rightSchema: {
    totalPrice: {
      title: 'userManagement.packageSubManagement.TOTAL_PRICE',
      key: 'amountVND',
    },
    tradeDiscountProduct: {
      title: 'userManagement.packageSubManagement.TRADE_DISCOUNT',
      key: 'discountValueVND',
    },
    tradeDiscount: {
      title: 'userManagement.packageSubManagement.TRADE_ORDER',
      key: 'discountValueVND',
    },
    vatPrice: {
      title: 'VAT',
      key: 'vatVND',
    },
    TOTAL: {
      title: 'userManagement.packageSubManagement.TOTAL',
      key: 'totalAmountVND',
    },
  },

  leftSchemaSubscription: {
    transactionNumber: {
      title: 'userManagement.packageSubManagement.TRANSACTION_NO',
      key: 'transactionCode',
    },
    requestNumber: {
      title: 'userManagement.packageSubManagement.REQUEST_NO',
      key: 'id',
    },
    requestType: {
      title: 'userManagement.packageSubManagement.REQUEST_TYPE',
      key: 'orderType',
    },
    type: {
      title: 'userManagement.packageSubManagement.TYPE',
      key: 'dataPackageName',
    },
    term: {
      title: 'subscriptionPayment.TERM',
      key: 'months',
    },
    requestStatus: {
      title: 'userManagement.packageSubManagement.REQUEST_STATUS',
      key: 'status',
    },
    paymentMethod: {
      title: 'userManagement.packageSubManagement.PAYMENT_METHOD',
      key: 'paymentMethod',
    },
    dateRequested: {
      title: 'userManagement.packageSubManagement.DATE_REQUESTED',
      key: 'createDate',
    },
    paymentStatus: {
      title: 'userManagement.packageSubManagement.PAYMENT_STATUS',
      key: 'transactionStatus',
    },
  },

  rightSchemaSubscription: {
    totalPrice: {
      title: 'userManagement.packageSubManagement.TOTAL_PRICE',
      key: 'amountVND',
    },
    tradeDiscount: {
      title: 'userManagement.packageSubManagement.TRADE_DISCOUNT',
      key: 'discountValueVND',
    },
    vatPrice: {
      title: 'VAT',
      key: 'vatVND',
    },
    TOTAL: {
      title: 'userManagement.packageSubManagement.TOTAL',
      key: 'totalAmountVND',
    },
  },
}

export const DETAIL_TABLE_SCHEMA = [
  { title: '#', key: 'order' },
  { title: 'userManagement.packageSubManagement.TYPE', key: 'name' },
  { title: 'userManagement.packageSubManagement.VOLUME', key: 'quantity' },
  { title: 'userManagement.packageSubManagement.PRICE', key: 'amountVND' },
]
